import api from "@/services/api";

const reportExpiringService = {
  getExpiring(params) {
    return api.get('/report/monitoring-document-h60', { params });
  },

  exportExcel(params) {
    return api.get('/report/monitoring-document-h60/export-excel', {
      params,
      responseType: 'blob',
    });
  },
};

export default reportExpiringService;
